import type { Location } from "react-router-dom";

/** Navigation state /login receives so it can send the user back where they were headed. */
export type LoginRedirectState = { from?: Pick<Location, "pathname" | "search" | "hash"> };

/** Where to go after a successful login: the page that bounced the user, else the cabinet. */
export function loginRedirectTarget(state: unknown): string {
  const from = (state as LoginRedirectState | null)?.from;
  if (!from?.pathname || from.pathname === "/login") return "/account";
  return `${from.pathname}${from.search ?? ""}${from.hash ?? ""}`;
}
